import { IPartnerDataFormData, IPartnerDataFormSettings } from './models'

export enum PartnerDataFormKeys {
  AdditionalInfo = 'onb-partner-editor-additional-info',
  Attachments = 'onb-partner-editor-attachments',
  BasicInfo = 'onb-partner-editor-basic-info',
  LegalInfo = 'onb-partner-editor-legal-info',
  Setting = 'onb-partner-editor-settings',
  Program = 'onb-partner-editor-program-code',
  Accreditation = 'onb-partner-editor-accreditation',
  MandatoryAttachments = 'onb-partner-editor-mandatory-attachments',
}

export enum PartnerDataFormSettings {
  ActualData = 'actualData',
  DoCopyBasicName = 'doCopyBasicName',
  DoCopyBasicAddress = 'doCopyBasicAddress',
  CurrentMenuItem = 'currentMenuItem',
  EditableMenuItems = 'editableMenuItems',
  IsInactive = 'isInactive',
  IsReadOnly = 'isReadOnly',
  IsLoading = 'isLoading',
}

export const DEFAULT_PARTNER_DATA_FORM_SETTINGS: IPartnerDataFormSettings = {
  actualData: {} as IPartnerDataFormData,
  doCopyBasicName: false,
  doCopyBasicAddress: false,
  currentMenuItem: 0,
  editableMenuItems: [],
  isInactive: false,
  isReadOnly: false,
  isLoading: false,
}

export const PARTNER_DATA_FORM_KEYS = {
  basic: PartnerDataFormKeys.BasicInfo,
  legal: PartnerDataFormKeys.LegalInfo,
  additional: PartnerDataFormKeys.AdditionalInfo,
  attachments: PartnerDataFormKeys.Attachments,
  settings: PartnerDataFormKeys.Setting,
}

export const READ_ONLY_BASIC_INFO_FIELDS = ['hierarchyType', 'topPartnerId']

export const PARTNER_CONTAINER_HEADER_HEIGHT = 80

export const isSaveAsDraft = true
